import { ReactComponent as ExclamationIcon } from "assets/images/icons/Exclamation.svg";

type QuoteErrorProps = {
  colSpan: number;
  errorMessage: string;
};

function QuoteError(props: QuoteErrorProps) {
  const { colSpan, errorMessage } = props;

  return (
    <tr className="quote-error-row">
      <td colSpan={colSpan}>
        <div className="quote-error-content">
          <ExclamationIcon className="mr-md" />
          <div className="align-self-center">{errorMessage}</div>
        </div>
      </td>
    </tr>
  );
}

export default QuoteError;
